import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import { RiDownloadLine } from "react-icons/ri";

export default function InstallAppButton() {
    const [canInstall, setCanInstall] = useState(false);

    useEffect(() => {
        if (window.__TWB_INSTALL_PROMPT__) {
            setCanInstall(true);
        }
    }, []);

    const handleInstall = async () => {
        const promptEvent = window.__TWB_INSTALL_PROMPT__;
        if (!promptEvent) return;

        promptEvent.prompt();
        const { outcome } = await promptEvent.userChoice;

        if (typeof window.gtag === 'function') {
            window.gtag("event", "pwa_install_prompt_result", { outcome });
        }

        window.__TWB_INSTALL_PROMPT__ = null;
        setCanInstall(false);
    };

    if (!canInstall) return null;

    return (
        <Button color="primary" size="sm" onClick={handleInstall}>
            <RiDownloadLine className="me-1" />
            Install App
        </Button>
    );
}
